module.exports = __webpack_public_path__ + "img/card.93ac6d3b.jpg";